export enum AnalyticsItemVariant {
  ARTICLE = "article",
  PLAYLIST = "playlist",
  PODCAST = "podcast",
  PODCAST_EPISODE = "podcast_episode",
  JOURNALS = "journals",

  ORGANISATION = "organisation",
  VIDEO_STORY = "video_story",
  VIDEO_ARTICLE = "video_article",
  INFOGRAPHIC = "infographic",
}

export enum AnalyticsItemCategory {
  STANDARD = "standard",
  SPONSORED = "sponsored",
}

export enum AnalyticsItemList {
  HOME = "home",
  FORYOU = "foryou",
  SEARCH = "search",
  PROFILE = "profile",
  // FILTERS = "filters",
  DISCOVERY_MAIN_CAROUSEL = "discovery_main_carousel",
  DISCOVERY_SECOND_CAROUSEL = "discovery_second_carousel",
  DISCOVERY_PLAYLISTS = "discovery_playlists",
  ARTICLE_PAGE = "article_page",
  AUTHOR_PAGE = "author_page",
  JOURNAL_PAGE = "journal_page",
  PLAYLIST_PAGE = "playlist_page",
  PLAYLIST_PANEL = "playlist_panel",

  GPT_ANSWER_SOURCES = "gpt_answer_sources",
  ORGANISATION_PAGE = "organisation_page",
  STORY_LIST_PAGE = "story_list_page",
  VIDEO_ARTICLE_PAGE = "videos_article_page",
  VIDEO_STORY_FEED = "video_story_feed",
  INFOGRAPHIC_PAGE = "infographic_page",
  ROOM_DISCOVERY = "room_discovery",
  /** Legacy "Conferences" page (a room tab of its own) */
  ROOM_CONGRESSES = "room_congresses",
  /** Content attached to a Congress Space, rendered inside the Resources tab */
  CONGRESS_SPACE = "congress_space",
  ROOM_RESOURCES = "room_resources",
  ROOM_PODCAST = "room_podcast",
  /** The practice rail — one shelf per relevance source (practice-profiles) */
  PRACTICE_RAIL = "practice_rail",
  /**
   * The practice feed — the `/discovery` surface in the practice-profile arm.
   * Distinct from the rail on purpose: the two answer different questions (does
   * a practitioner engage with a shelf, versus with a whole feed), and merging
   * them under one list name would make neither readable.
   */
  PRACTICE_FEED = "practice_feed",
}

export enum AnalyticsNavElementType {
  BOTTOM_BAR = "bottom_bar",
  CHANGE_LANGUAGE = "change_language",
  SHARE_ROOM = "share_room",
  PAGE_LINK = "page_link",
  GPT_RESUME_CHAT = "juisci_gpt_resume_chat",
}

export enum AnalyticsNavElementName {
  DISCOVERY = "discovery",
  GPT = "juisciGPT",
  FORYOU = "for_you",
  SEARCH = "search",
  PROFILE = "profile",
  RESOURCES = "resources",
  ROOMS = "rooms",
}

export enum AnalyticsNavPageLink {
  BECOME_CERTIFIED = "become_certified",
  CHAT_WITH_JUISCI_GPT = "chat_with_juisci_gpt",
  //  VIDEO_#VIDEO_NAME# = "video_#video_name#",
  //  PLAYLIST_#PLAYLIST_NAME# = "playlist_#playlist_name#",
  //  COMMUNITY_#NAME# = "community_#name#",
  //  #PUBLICATION_#NAME#_#SUBTITLE#, = "#publication_#name#_#subtitle#",
}

export type AnalyticsOrigin = "public app" | "room";

export const AUDIO_PERCENTAGES = [5, 10, 25, 50, 75, 100];
